import TextFieldWrapper from '../../ui/forms/field_wrappers/text/text';

type SubclipTitleTextProps = {
  title: string;
  onTitleChange: (title: string) => void;
};

export function SubclipTitleText({
  title,
  onTitleChange,
}: SubclipTitleTextProps) {
  return (
    <TextFieldWrapper
      name="subclip_title"
      required
      value={title}
      label="Subclip Title"
      onChange={(value) => {
        onTitleChange?.(value ?? '');
      }}
    />
  );
}
